import React from 'react'
import { DayforceJobProvider } from '../../context/DayforceJobProvider'
import { JobDetailsMain } from './components/JobDetailsMain'

export const JobDetails = ({
  agencyId,
  jobId,
}: {
  agencyId: string
  jobId: string
}) => {
  return (
    <DayforceJobProvider agencyId={agencyId} jobId={jobId}>
      <JobDetailsMain />
    </DayforceJobProvider>
  )
}
